import React from "react";
import { Theme, useTheme, css } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    className?: string,
    type?: string,
    useSmallPadding?: boolean,
};

const PageSection: React.FC<Props> = ({
    children,
    className = '',
    type = '',
    useSmallPadding = false,
}) => {
    const theme: Theme = useTheme();

    const style = css`
        width: 100%;
        
        ${useSmallPadding ? css`
            ${theme.breakpoints.up("5xl")} {
                max-width: 1816px;
                padding: 26px 0;
            }
    
            ${theme.breakpoints.between("3xl", "4xl")} {
                max-width: 1794px;
                padding: 43px 0;
            }

            ${theme.breakpoints.only("xxl")} {
                max-width: 1281px;
                padding: 34px 0;
            }

            ${theme.breakpoints.only("xl")} {
                max-width: 1120px;
                padding: 25px 0;
            }
    
            ${theme.breakpoints.between("md", "lg")} {
                max-width: 864px;
                padding: 31px 0;
            }
    
            ${theme.breakpoints.down("sm")} {
                max-width: 353px;
                padding: 19px 0;
            }
        ` : css`
            ${theme.breakpoints.up("5xl")} {
                max-width: ${theme.breakpoints.sizes["5xl"]}px;
                padding: 56px 202px;
            }
    
            ${theme.breakpoints.between("3xl", "4xl")} {
                max-width: ${theme.breakpoints.sizes["3xl"]}px;
                padding: 60px 80px;
            }
    
            ${theme.breakpoints.only("xxl")} {
                max-width: ${theme.breakpoints.sizes.xxl}px;
                padding: 92px 80px;
            }
    
            ${theme.breakpoints.only("xl")} {
                max-width: ${theme.breakpoints.sizes.xl}px;
                padding: 45px 83px;
            }
    
            ${theme.breakpoints.only("lg")} {
                max-width: ${theme.breakpoints.sizes.lg}px;
                padding: 27px 45px;
            }
    
            ${theme.breakpoints.only("md")} {
                max-width: ${theme.breakpoints.sizes.md}px;
                padding: 33px 45px;
            }
            
            ${type === 'success-story' ? css`
                ${theme.breakpoints.only("sm")} {
                    max-width: ${theme.breakpoints.sizes.sm}px;
                    padding: 33px 40px;
                }
    
                ${theme.breakpoints.down("xs")} {
                    max-width: ${theme.breakpoints.sizes.xs}px;
                    padding: 33px 20px;
                }
            ` : css`
                ${theme.breakpoints.down("sm")} {
                    max-width: 297px;
                    padding: 33px 0;
                }
            `}
        `}
    `;

    return (
        <div css={style} className={className}>
            {children}
        </div>
    );
}

export default PageSection;
